import React, { useState } from 'react';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { View } from '@uncinc/react-drupal-core';

const ParagraphRecentArticles = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({});

  return (
    <Container className="NodeArticleDetail__recent__articles">
      <div className="row">
        <div className="col-12">
          <View
            id="recent_articles"
            display="block_1"
            page={currentPage}
            filters={filters}
            setFilters={setFilters}
            setCurrentPage={setCurrentPage}
            label="latest_news"
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphRecentArticles;
